import supreme from '../supreme'
import {guid,copy} from '../util/util'
var key = "supreme_history"
// 历史轨迹
export default{
  // 同步到历史记录
  asyncTaskStack(taskStack){
    var vueArray=[];
    for(var i=0;i<taskStack.length;i++){
      vueArray.push(taskStack[i].vue)
      delete taskStack[i].vue;
    }
    supreme.sessionCache.set(key,{taskStack:taskStack});
    for(var j=0;j<taskStack.length;j++){
        taskStack[j].vue=vueArray[j];
    }
    //if()
  },
  //获取本地存储的浏览历史
  getLocalTaskHistory(){
    return supreme.sessionCache.get(key)?supreme.sessionCache.get(key).taskStack:[];
  },
  clear(){
    supreme.sessionCache.delete(key);
  }

}
